import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
import { Helmet } from "react-helmet";
import { Controller, useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import * as yup from "yup";

const Loginpage = (props) => {
  const schema = yup.object({
    // email: yup
    //   .string()
    //   .matches(window?.constant?.emailrgx, "Email is required")
    //   .required("Email is required")
    //   .trim(),
    password: yup.string().min(6).required("Password is required").trim(),
  });

  const [eye, seteye] = useState(true);
  const [loader, setLoader] = useState(false);
  const {
    control: control,
    handleSubmit: handlePasswordSubmit,
    setError: setError,
    clearErrors,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onPasswordSubmit = (data) => {
    console.log("onPasswordSubmit", data);
    const payload = {
      email_address: data.email_address?.toLowerCase(),
      password: data.password,
    };
    var validRegex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if (data?.email_address?.match(validRegex)) {
      payload["email_address"] = data.email_address?.toLowerCase();
    }

    console.log({ payload });

    setLoader(true);

    props.api
      .apiCustomerLogin(payload)
      .then((res) => {
        console.log({ res });
        props.setstore("logged", res.logged);
        props.setstore("auth", res.auth);
        props.setstore("user", res.user);
        clearErrors("password");
      })
      .catch(() => {
        setError("password", {
          message: "login failed",
        });
        setLoader(false);
      });
  };

  const onEyeClick = () => {
    seteye(!eye);
  };

  return (
    <>
      {loader && (
        <div className="loader-container">
          <div className="spinner"></div>
        </div>
      )}
      <Helmet>
        <title>Login - CognoSpace</title>
        <meta name="description" content="Login page" />
      </Helmet>
      <div className="account-content">
        <div className="container">
          <div className="account-box">
            <div className="account-wrapper">
              <div className="py-3 d-flex justify-content-center">
                <Link to={"/open/login"}>
                  <img
                    src={imagepaths.CognoSpaceLogoDark}
                    alt="Logo"
                    width="155px"
                  />
                </Link>
              </div>
              <h3 className="account-title">Login</h3>
              <p className="account-subtitle">Access to our dashboard</p>

              <form
                className="email_form"
                key={2}
                onSubmit={handlePasswordSubmit(onPasswordSubmit)}
              >
                <>
                  <div className="form-group">
                    <label>Email ID</label>
                    <Controller
                      name="email_address"
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <input
                          className={`form-control  ${
                            errors?.required ? "error-input" : ""
                          }`}
                          type="text"
                          value={value}
                          onChange={onChange}
                          autoComplete="false"
                          placeholder="Enter email id"
                          required={true}
                        />
                      )}
                    />
                    <small>{errors?.required?.message}</small>
                  </div>

                  <div className="form-group">
                    <div className="row">
                      <div className="col">
                        <label>Password</label>
                      </div>
                    </div>
                    <Controller
                      name="password"
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <div className="pass-group">
                          <input
                            type={eye ? "password" : "text"}
                            className={`form-control  ${
                              errors?.password ? "error-input" : ""
                            }`}
                            value={value}
                            onChange={onChange}
                            autoComplete="false"
                            placeholder="Enter your password here"
                            required={true}
                          />
                          <span
                            onClick={onEyeClick}
                            className={`fa toggle-password" ${
                              eye ? "fa-eye-slash" : "fa-eye"
                            }`}
                          />
                        </div>
                      )}
                    />
                    <p className="mt-3">
                      <a
                        className="text-dark text-decoration-underline"
                        href="https://cognospace.in/privacy-policy.html"
                        target="_blank"
                      >
                        Privacy Policy
                      </a>{" "}
                    </p>
                    <small>{errors?.password?.message}</small>
                    <div className="col-auto d-flex justify-content-between">
                      <Link
                        className="text-muted ms-auto"
                        to="/open/forgotpassword"
                      >
                        Forgot password?
                      </Link>
                    </div>
                  </div>

                  <div className="form-group text-center">
                    <button
                      className="btn btn-primary account-btn"
                      type="submit"
                    >
                      Login
                    </button>
                  </div>
                </>
              </form>
              <div className="account-footer">
                <p className="text-black">
                  Not a member?
                  <Link to="/open/register"> Sign Up</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(Loginpage);
